import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface ChannelFilters {
  eventName: string
}

export interface ChannelRecord {
  rowId: string
  title: string
  eventName: string
  headImgUrl: string
  liveUrl: string
}

export async function fetchChannelPage(
  query: PageQuery<ChannelFilters>,
  signal: AbortSignal
): Promise<PageResult<ChannelRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/customerEvents/queryByCondition',
    params: {
      ...query.filters,
      pageNo: query.pageNo,
      pageSize: query.pageSize
    },
    signal
  })
  return normalizePageResult<ChannelRecord>(payload)
}

export async function generateChannelUrl(rowId: string) {
  const url = await requestV2.post<unknown>({
    url: `/main/liveBuryGenerate/generate/${rowId}`
  })
  if (typeof url !== 'string') throw new Error('复制链接响应必须是字符串')
  return url
}

export function downloadChannelQrCode(rowId: string) {
  return requestV2.get<Blob>({
    url: `/main/liveBuryGenerate/generate/qrcode/${rowId}`,
    responseType: 'blob'
  })
}
